'use client';

import { Link } from 'react-router-dom';
import { ArrowLeft, Pizza, Phone, MapPin, Globe, Instagram, Facebook } from 'lucide-react';
import Footer from '@/components/Footer';


const LANCHES_PIZZAS = [
  { name: "A Cantina", number: "(45) 99152-3513", address: "Rua Presidente Kennedy esquina com Rua Presidente Castelo Branco, Centro", whatsapp: "https://wa.me/5545991523513", app: "https://app.anota.ai/m/5Mn7h9wcw" },
  { name: "Bora Bora Pizzaria", number: "(45) 99983-2084", address: "Rua Rio Grande do Sul, Loteamento Dona Bela", whatsapp: "https://wa.me/5545999832084", instagram: "https://www.instagram.com/borabora.pizzaria/", app: "https://pedido.anota.ai/loja/bora-bora-choperia-1" },
  { name: "Duffeck Pizzaria", number: "(45) 99830-3057", address: "Rua Presidente Kennedy, Centro", whatsapp: "https://wa.me/5545998303057", instagram: "https://www.instagram.com/duffeckpizzaria/", app: "https://akitem.app/duffeckpizzaria" },
  { name: "Pizzaria Monteiro", number: "(45) 9146-9362", address: "Rua Duque de Caxias, Bairro Menino Deus", whatsapp: "https://wa.me/554591469362", instagram: "https://www.instagram.com/pizzariamonteiro1/", facebook: "https://www.facebook.com/p/Disk-Pizza-Monteiro-100057683040876/" },
  { name: "Pizzaria Paladar", number: "(45) 98407-1778", address: "Rua Dom Pedro II", whatsapp: "https://wa.me/5545984071778", instagram: "https://www.instagram.com/pizzaria_paladar_catanduvas/", facebook: "https://www.facebook.com/p/Pizzaria-Paladar-100059052434319" },
  { name: "Pizzaria Pedrinho", number: "(45) 99920-9183", address: "Av. Adolfo Chagas, 449, Bairro Alto Alegre", whatsapp: "https://wa.me/5545999209183", instagram: "https://www.instagram.com/lanchonetedopedrinhoctvas/", facebook: "https://www.facebook.com/lanchonetedopedrinhoctvas/", app: "https://pedir.delivery/app/pizzariapedrinho/menu" },
].sort((a, b) => a.name.localeCompare(b.name));

export default function LanchesPizzasPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-amber-200 selection:text-amber-900">
      {/* Header */}
      <header className="bg-gradient-to-r from-amber-600 to-yellow-700 text-white shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center space-y-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 px-6 py-3 rounded-2xl text-white font-black uppercase tracking-tighter italic transition-all hover:-translate-x-1 active:scale-95 mb-8 group shadow-lg"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Voltar para o Início
          </Link>
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase italic">
            Lanches e Pizzas <br className="md:hidden" />
            <span className="text-amber-200">Catanduvas PR</span>
          </h1>
          <p className="text-amber-100 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Bateu aquela fome? Peça um lanche ou uma pizza agora mesmo.
          </p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 -mt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-slate-100">
          <div className="flex items-center gap-3 mb-10">
            <div className="bg-amber-100 p-3 rounded-2xl">
              <Pizza className="w-8 h-8 text-amber-600" />
            </div>
            <div>
              <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic">Lista de Empresas</h2>
              <p className="text-slate-500 font-bold text-sm">Clique nos botões coloridos para pedir ou acessar redes</p>
            </div>
          </div>

          <div className="space-y-6">
            {LANCHES_PIZZAS.map((item, i) => (
              <div key={i} className="bg-slate-50 rounded-3xl p-6 border border-slate-100 group hover:bg-white hover:shadow-xl transition-all">
                <h3 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic mb-4">{item.name}</h3>
                <p className="text-slate-600 text-sm font-bold flex items-start gap-2 mb-6">
                  <MapPin className="w-5 h-5 flex-shrink-0 text-amber-500" />
                  {item.address}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <a 
                    href={`tel:${item.number.replace(/\D/g, '')}`}
                    className="flex items-center justify-center gap-2 bg-sky-500 hover:bg-sky-600 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-sky-200"
                  >
                    <Phone className="w-5 h-5" />
                    Ligar: {item.number}
                  </a>
                  <a 
                    href={item.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-emerald-200"
                  >
                    WhatsApp
                  </a>
                  {item.app && (
                    <a 
                      href={item.app}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 bg-violet-600 hover:bg-violet-700 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-violet-200"
                    >
                      <Globe className="w-5 h-5" />
                      Pedir pelo App
                    </a>
                  )}
                  {item.instagram && (
                    <a 
                      href={item.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 bg-pink-600 hover:bg-pink-700 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-pink-200"
                    >
                      <Instagram className="w-5 h-5" />
                      Instagram
                    </a>
                  )}
                  {item.facebook && (
                    <a 
                      href={item.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 bg-blue-800 hover:bg-blue-900 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-blue-200"
                    >
                      <Facebook className="w-5 h-5" />
                      Facebook
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
